<template>
    <div class="flex items-center gap-2 cursor-pointer">
        <div v-if="props.selected !== undefined" data-test="thread-selection-icon">
            <font-awesome-icon
                widthAuto
                v-if="props.selected"
                :icon="faCircleCheck"
                class="text-sky-500"
            ></font-awesome-icon>
            <font-awesome-icon widthAuto v-else :icon="faCircle" class="text-slate-400"></font-awesome-icon>
        </div>

        <component
            :is="props.selected !== undefined ? 'div' : RouterLink"
            :to="props.to"
            data-test="row-item"
            class="cursor-pointer max-w-full no-underline! flex-1 px-3.5 py-2.5 block rounded-[10px] relative transition hover:bg-slate-50"
            :class="{
                'bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),0px_1px_2px_0px_rgba(0,0,0,0.06)]': !props.active,
                'bg-sky-50 outline-2 outline-sky-500 shadow-[0px_10px_15px_-3px_rgba(5,71,107,0.12),0px_4px_6px_-2px_rgba(5,71,107,0.10)]':
                    props.active,
                'active:scale-95': props.selected !== undefined,
            }"
        >
            <div
                v-if="props.unread && !props.active"
                class="absolute inset-bs-0 inset-s-0 bg-sky-400 w-[6px] h-full rounded-tl-[10px] rounded-bl-[10px]"
            ></div>
            <div class="flex flex-col gap-0.5">
                <div class="flex flex-row items-baseline justify-between">
                    <span
                        class="font-semibold text-sm leading-tight"
                        :class="[props.active ? 'text-sky-900' : 'text-slate-800']"
                    >
                        <slot name="title"></slot>
                    </span>
                    <span class="text-xs leading-4" :class="[props.active ? 'text-sky-600' : 'text-slate-500']">
                        <slot name="date"></slot>
                    </span>
                </div>
                <span
                    class="text-xs leading-tight break-words line-clamp-1 [@media(min-height:1000px)]:line-clamp-2"
                    :class="[props.active ? 'text-sky-600' : 'text-slate-500']"
                >
                    <slot name="content"></slot>
                </span>
            </div>

            <slot name="afterContent"></slot>

            <div v-if="slots.badges" class="mt-1 mb-0.5 space-x-1">
                <slot name="badges"></slot>
            </div>
        </component>
    </div>
</template>

<script setup>
import { useSlots } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { RouterLink } from 'vue-router';

const props = defineProps({
    active: {
        type: Boolean,
        default: false,
    },
    unread: {
        type: Boolean,
        default: false,
    },
    to: {
        type: Object,
        default: () => ({}),
    },
    selected: {
        type: Boolean,
        required: false,
    },
});

const slots = useSlots();
</script>
